import React from 'react';
import { useTranslation } from 'react-i18next';
import Container from '../common/components/Container/Container';
import Loading from '../common/components/Loading/Loading';
import TitleContainer from '../common/components/TitleContainer/TitleContainer';
import withRouteAnalytics from '../services/analytics/withRouteAnalytics';
import { Screens } from '../services/analytics/screens';

function ConfirmWalletTransactionScreen(): JSX.Element {
  const { t } = useTranslation();

  return (
    <Container>
      <TitleContainer>
        <h1 className="mb-4">{t('screens.confirmWalletTransaction.title')}</h1>
        <p className="mb-4 leading-snug">{t('screens.confirmWalletTransaction.description')}</p>
      </TitleContainer>
      <Loading />
    </Container>
  );
}

export default withRouteAnalytics(ConfirmWalletTransactionScreen, Screens.CONFIRM_WALLET_TRANSACTION);
